import { useQuery } from '@tanstack/react-query';
import { fetchPublicSettings } from '@/api/settings';
import { CONTACT } from '@/lib/labels';
import { normalizePhone } from '@/lib/phone';

export interface Contact {
  companyName: string;
  phone: string;
  phoneHref: string;
  email: string;
  address: string;
  weekdayHours: string;
  weekendHours: string;
  serviceArea: string;
}

const DEFAULT_CONTACT: Contact = {
  companyName: 'Ápolási betegágy bérlés',
  phone: CONTACT.phone,
  phoneHref: CONTACT.phoneHref,
  email: CONTACT.email,
  address: '',
  weekdayHours: CONTACT.weekdayHours,
  weekendHours: CONTACT.weekendHours,
  serviceArea: CONTACT.serviceArea
};

export const usePublicSettings = () => useQuery({ queryKey: ['public', 'settings'], queryFn: fetchPublicSettings, staleTime: 5 * 60_000, retry: 1 });

export const useContact = (): Contact => {
  const settings = usePublicSettings();
  const values = settings.data;
  if (!values) return DEFAULT_CONTACT;

  const phone = values.COMPANY_PHONE || DEFAULT_CONTACT.phone;
  return {
    companyName: values.COMPANY_NAME || DEFAULT_CONTACT.companyName,
    phone,
    phoneHref: `tel:${normalizePhone(phone)}`,
    email: values.COMPANY_EMAIL || DEFAULT_CONTACT.email,
    address: values.COMPANY_ADDRESS || '',
    weekdayHours: values.OPENING_HOURS_WEEKDAY ? `Hétköznap ${values.OPENING_HOURS_WEEKDAY}` : DEFAULT_CONTACT.weekdayHours,
    weekendHours: values.OPENING_HOURS_WEEKEND ? `hétvégén ${values.OPENING_HOURS_WEEKEND}` : DEFAULT_CONTACT.weekendHours,
    serviceArea: values.SERVICE_AREA || DEFAULT_CONTACT.serviceArea
  };
};
